
// saga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_SOLUTIONS,
  ADD_SOLUTION,
  UPDATE_SOLUTION,
  DELETE_SOLUTION,
} from './actionTypes';
import {
  getSolutionsSuccess,
  getSolutionsFail,
  addSolutionSuccess,
  addSolutionFail,
  updateSolutionSuccess,
  updateSolutionFail,
  deleteSolutionSuccess,
  deleteSolutionFail,
} from './actions';
import axiosInstance from 'pages/Utility/axiosInstance';
import toast from 'react-hot-toast';

// ---------------- API Calls ----------------
const fetchSolutionsApi = () => axiosInstance.get('', { params: { sp: 'usp_GetSolutions' } })
const addSolutionApi = (solution) => axiosInstance.post('https://wpr.intertoons.net/fonzcrmapi/', solution);
const updateSolutionApi = (solution) => axiosInstance.post('https://wpr.intertoons.net/fonzcrmapi/', solution);
const deleteSolutionApi = (solutionId) => axiosInstance.post('https://wpr.intertoons.net/fonzcrmapi/', { sp: 'usp_DeleteSolution', solutionId });

// ---------------- Sagas ----------------
function* getSolutionsSaga() {
  try {
    const { data } = yield call(fetchSolutionsApi);
    yield put(getSolutionsSuccess(data?.Data || []));
  } catch (error) {
    yield put(getSolutionsFail(error.response?.data || error.message));
  }
}

function* addSolutionSaga(action) {
  try {
    const response = yield call(addSolutionApi, action.payload.data);
    yield put(addSolutionSuccess());
    toast.success('Solution added successfully!');
    action.payload.onClose()
    yield put({ type: GET_SOLUTIONS });
  } catch (error) {
    yield put(addSolutionFail(error.response?.data || error.message));
  }
}

function* updateSolutionSaga(action) {
  try {
    const { data } = yield call(updateSolutionApi, action.payload.data);
    yield put(updateSolutionSuccess(data));
    action.payload.onClose()
    toast.success('Solution updated successfully!');
    yield put({ type: GET_SOLUTIONS });
  } catch (error) {
    yield put(updateSolutionFail(error.response?.data || error.message));
  }
}

function* deleteSolutionSaga(action) {
  try {
    yield call(deleteSolutionApi, action.payload);
    yield put(deleteSolutionSuccess(action.payload));
    toast.success('Solution deleted successfully!');
    yield put({ type: GET_SOLUTIONS });
  } catch (error) {
    yield put(deleteSolutionFail(error.response?.data || error.message));
  }
}

// ---------------- Watcher Saga ----------------
function* solutionSaga() {
  yield takeEvery(GET_SOLUTIONS, getSolutionsSaga);
  yield takeEvery(ADD_SOLUTION, addSolutionSaga);
  yield takeEvery(UPDATE_SOLUTION, updateSolutionSaga);
  yield takeEvery(DELETE_SOLUTION, deleteSolutionSaga);
}

export default solutionSaga;
